/*
 * January Moon — PDP thumbnail carousel drag-to-scroll.
 *
 * Adds click-and-drag (mouse / pen) horizontal scrolling to the product
 * thumbnail strip so slides can be moved without the nav arrows.
 * Touch devices keep their native swipe scrolling untouched.
 *
 * A plain click is left completely alone (so clicking a thumbnail still
 * switches the main gallery image). Drag only engages once the pointer
 * moves past a small threshold — only then is the trailing click swallowed.
 *
 * Target: `.jm-thumbs-drag [id^="Slider-Thumbnails-"]` (the scroll track).
 * Idempotent — safe to run multiple times / on shopify:section:load.
 */
(function () {
  var THRESHOLD = 6; // px the pointer must move before it counts as a drag

  function initDrag(slider) {
    if (!slider || slider.dataset.jmDragReady === '1') return;
    slider.dataset.jmDragReady = '1';

    var pending = false; // pointer is down, drag not yet started
    var dragging = false; // movement has passed the threshold
    var didDrag = false; // a real drag happened during this press
    var startX = 0;
    var startScroll = 0;
    var pointerId = null;

    slider.addEventListener('pointerdown', function (e) {
      // Touch keeps native momentum scrolling.
      if (e.pointerType === 'touch') return;
      // Mouse: primary (left) button only.
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      // Nothing to scroll (grid / wrapped thumbnails) — don't touch clicks.
      if (slider.scrollWidth <= slider.clientWidth + 2) return;

      pending = true;
      dragging = false;
      didDrag = false;
      startX = e.clientX;
      startScroll = slider.scrollLeft;
      pointerId = e.pointerId;
      // NOTE: no setPointerCapture / preventDefault here — a plain click
      // must stay a normal click.
    });

    slider.addEventListener('pointermove', function (e) {
      if (!pending) return;
      var dx = e.clientX - startX;

      if (!dragging) {
        if (Math.abs(dx) < THRESHOLD) return; // still just a click
        dragging = true;
        didDrag = true;
        slider.classList.add('jm-dragging');
        try {
          slider.setPointerCapture(pointerId);
        } catch (err) {
          /* noop */
        }
      }

      slider.scrollLeft = startScroll - dx;
      e.preventDefault();
    });

    function end() {
      if (!pending) return;
      pending = false;
      if (dragging) {
        dragging = false;
        slider.classList.remove('jm-dragging');
        try {
          slider.releasePointerCapture(pointerId);
        } catch (err) {
          /* noop */
        }
      }
      pointerId = null;
    }

    slider.addEventListener('pointerup', end);
    slider.addEventListener('pointercancel', end);

    // Only swallow the click that follows a *real* drag, so dragging doesn't
    // accidentally switch the main gallery image. Plain clicks pass through.
    slider.addEventListener(
      'click',
      function (e) {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
          didDrag = false;
        }
      },
      true
    );
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('.jm-thumbs-drag [id^="Slider-Thumbnails-"]')
      .forEach(initDrag);
  }

  if (document.readyState !== 'loading') {
    initAll();
  }
  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });
  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
